module.exports = __webpack_public_path__ + "media/images/img_top_explain01-5129c733325150e3c35c8b22501d815f.jpg";